import React, { Component } from 'react';
import FilterSelect from './FilterSelect';
import FilterInput from './FilterInput';

class Filter extends Component {

	constructor(props)
	{
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(fld)
	{
		this.props.onFilterChange(fld);
	}

	render()
	{
		var el   = null;
		var data = this.props.data;

		switch(data.type)
		{
			case 'select':
				el = <FilterSelect name={ data.key } selected={ data.selected } options={ data.options } onChange={ this.handleChange } />;
				break;
			case 'number':
			case 'text':
				el = <FilterInput name={ data.key } type={ data.type } selected={ data.selected } onChange={ this.handleChange } />;
				break;
		}

		return (
			<div className="filter">

				<label htmlFor={ data.key } className="filter__label">{ data.title }</label>

				<div className="filter__field">

					{ el }

				</div>

			</div>
		);
	}
}

export default Filter;
